var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51395 1.6958C8.96322 1.79564 9.2465 2.24079 9.14666 2.69007L8.44609 5.84263H13.4054L14.1863 2.32852C14.2862 1.87924 14.7313 1.59596 15.1806 1.6958C15.6299 1.79564 15.9132 2.24079 15.8133 2.69007L15.1128 5.84263H17.4998C17.9601 5.84263 18.3332 6.21572 18.3332 6.67596C18.3332 7.1362 17.9601 7.50929 17.4998 7.50929H14.7424L13.6313 12.5093H16.6665C17.1267 12.5093 17.4998 12.8824 17.4998 13.3426C17.4998 13.8029 17.1267 14.176 16.6665 14.176H13.2609L12.48 17.6901C12.3802 18.1393 11.935 18.4226 11.4857 18.3228C11.0365 18.2229 10.7532 17.7778 10.853 17.3285L11.5536 14.176H6.59424L5.81333 17.6901C5.71349 18.1393 5.26834 18.4226 4.81906 18.3228C4.36978 18.2229 4.08651 17.7778 4.18635 17.3285L4.88692 14.176H2.49984C2.0396 14.176 1.6665 13.8029 1.6665 13.3426C1.6665 12.8824 2.0396 12.5093 2.49984 12.5093H5.25729L6.3684 7.50929H3.33317C2.87293 7.50929 2.49984 7.1362 2.49984 6.67596C2.49984 6.21572 2.87293 5.84263 3.33317 5.84263H6.73877L7.51968 2.32852C7.61952 1.87924 8.06467 1.59596 8.51395 1.6958ZM8.07572 7.50929L6.96461 12.5093H11.924L13.0351 7.50929H8.07572Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBatch);
export default __webpack_public_path__ + "static/media/menuBatch.9e19557c7268e4bdd8599ee8a86e0f76.svg";
export { ForwardRef as ReactComponent };